"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlStopEventPropagation", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.click(function (e) {
        e.stopPropagation();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlStopEventPropagation.js
// module id = 2909
// module chunks = 13